import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ListingTable from './PriceListing';
import AddPriceBook from './AddPriceBook';
import AddEditPriceProd from './AddEditPriceProd';
import GeneralPriceBook from './GeneralPriceBook';
import ProductDetail from './ProductDetail';
import PriceBookImport from './PriceBookImport';

const PriceBook = ({ match }) => (
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/booklisting`} />
        <Route path={`${match.url}/booklisting`} component={ListingTable} />
        <Route path={`${match.url}/addbook`} component={AddPriceBook} />
        <Route path={`${match.url}/customprices`} component={AddEditPriceProd} />
        <Route path={`${match.url}/generalpricebook`} component={GeneralPriceBook} />
        <Route path={`${match.url}/productdetail`} component={ProductDetail} />
        <Route path={`${match.url}/import/:id`} component={PriceBookImport} />
    </Switch>
);

export default PriceBook;
